<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" :title="title" centered destroyOnClose width="70%">
    <a-space>
      <vxe-input v-model="query['no']" clearable placeholder="business.label.no" size="small" type="search" @search-click="search"/>
      <vxe-input v-model="query['name']" clearable placeholder="business.label.name" size="small" type="search" @search-click="search"/>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      :height="height"
      style="margin-top: 2px"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="no" title="business.label.no" width="100"/>
      <vxe-column field="name" title="business.label.name" width="180"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="refundable" title="business.label.refundable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="shortable" title="business.label.shortable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supplemental" title="business.label.supplemental" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="mergeOrder" title="business.label.mergeOrder" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoSubmit" title="business.label.autoSubmit" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoApproval" title="business.label.autoApproval" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoAsn" title="business.label.autoAsn" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoReceiving" title="business.label.autoReceiving" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoAccepting" title="business.label.autoAccepting" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoPutaway" title="business.label.autoPutaway" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoCompletion" title="business.label.autoCompletion" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoRetry" title="business.label.autoRetry" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoInversionApproval" title="business.label.autoInversionApproval" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoReview" title="business.label.autoReview" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoDistribution" title="business.label.autoDistribution" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoHandover" title="business.label.autoHandover" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoCleanup" title="business.label.autoCleanup" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import { findAll } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'OrderTypeModal',
  data() {
    return {
      show: true,
      page: 1,
      size: 15,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: { no: '', name: '' },
      args: { operationType: 0 },
      selectedRows: [],
      record: undefined,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.65)
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    title: {
      type: String,
      default: '订单类型检索'
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    init(args) {
      this.query = { no: '', name: '' }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.loading = true
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    getData() {
      this.loading = true
      findAll('orderTypeFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>